export enum RecommendationsPanels {
  AddedToBasketNotification = 'AddedToBasketNotification',
  AddedToBasketNotificationPane = 'AddedToBasketNotificationPane',
  BelowCBasket = 'BelowCBasket',
  BelowConfigStrip = 'BelowConfigStrip',
  Checkout = 'Checkout',
  Checkout2 = 'Checkout2',
  Spotlight = 'Spotlight',
  PBasket = 'PBasket',
  SearchBar = 'SearchBar',
  SearchSuggestBar = 'SearchSuggestBar',
  SearchProducts = 'SearchProducts',
  ProductBasketHeader = 'ProductBasketHeader',
}
